import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class PostCard extends Component {

    render() {
        return (
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-xs-12 card-body">
                <img className="w-100" src={this.props.postData.main_image ? this.props.postData.main_image : "/static/img/post-image.png"} alt="cover-card" />
                <div className="texts-body">
                    <Link to={"/wiki/" + this.props.postData.id}>
                        <h4 style={{color: "black"}}>{this.props.postData.title}</h4>
                    </Link>

                    <p>
                        {this.props.postData.description}
                    </p>
                    <Link to={"/wiki/" + this.props.postData.id}>
                        <button className="btn-more"> ادامه مطلب </button>
                    </Link>
                </div>
            </div>
        )
    }
}